import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ICategoryTreeNode} from "../tree-service/tree-data.model";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-edit-node',
    templateUrl: './edit-node.component.html',
    styleUrls: ['./edit-node.component.css']
})
export class EditNodeComponent implements OnInit {
    @ViewChild("editNodeModal", {read: TemplateRef}) editNodeModal: TemplateRef<any>;

    @Input() currentNode: ICategoryTreeNode;
    @Output() edittedNode = new EventEmitter();

    dialogRef: MatDialogRef<any>;
    name = '';

    constructor(public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.name = this.currentNode?.Name;
    }

    openDialog(): void {
        this.dialogRef = this.dialog.open(this.editNodeModal, {
            width: '250px',
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onAdd(): void {
        if (this.name) {
            const node: ICategoryTreeNode = {
                Id: null,
                Name: this.name,
                Children: this.currentNode.Children
            };
            this.edittedNode.emit({currentNode: this.currentNode, node: node});
            this.dialogRef.close();
        }
    }
}
